module.exports = __webpack_public_path__ + "img/attachment-excel.8292f099.svg";